import {CustomInputProps} from '../components/custom-input';

export const getCustomInput =
  <T,>(data: Omit<CustomInputProps<T>, 'type'>) =>
  (): CustomInputProps<T> => ({
    ...data,
    type: 'custom',
  });
